import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "PeopleCard"  */ './lazyIndex')
);

//TODO: WI 56073: User react's lazy and suspense components for loading the card
export const PeopleCardModule = createLazyComponent(lazyModule, m => m.PeopleCardModule);
